// extracted by mini-css-extract-plugin
module.exports = {"transportInformation":"transportDetails_transportInformation__2CMit"};